import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ErrorStore,
  FormHeaderComponent,
  GlobalErrorComponent,
  IdentityStore,
  LogInCredentials,
  LoginFormComponent,
  TenantStore,
} from '../../../index';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { FaIconComponent, MessageComponent } from '@akostm/orbit-ui';

@Component({
  selector: 'shared-main-login',
  standalone: true,
  imports: [
    CommonModule,
    LoginFormComponent,
    FaIconComponent,
    MessageComponent,
    TranslatePipe,
    FormHeaderComponent,
    GlobalErrorComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  readonly tenantStore = inject(TenantStore);
  readonly #identityStore = inject(IdentityStore);
  readonly spinnerIcon = faSpinnerThird;
  readonly #errorStore = inject(ErrorStore);
  readonly #loginErrorCodes = [
    'error.identity.invalid_credentials',
    'error.identity.user_not_found_or_disabled',
  ];
  readonly loginErrors = computed(() =>
    this.#errorStore.getErrorsByCodesAndType(this.#loginErrorCodes, 'inline')
  );
  readonly #tenantErrorCodes = [
    'error.identity.tenant_not_found_or_disabled',
    'error.frontends.tenant_not_found_or_disabled',
  ];
  readonly tenantErrors = computed(() =>
    this.#errorStore.getErrorsByCodesAndType(this.#tenantErrorCodes, 'global')
  );

  loginAttempt(credentials: LogInCredentials) {
    this.resetLoginErrors();
    this.#identityStore.signInWithEmailAndPassword(credentials.email, credentials.password);
  }

  resetLoginErrors() {
    this.#errorStore.clearErrorsByCodes(this.#loginErrorCodes);
  }
}
